import { Button } from "antd";

export default function NoPresetMask({ presetList, onAddPreset }) {
  return (
    <>
      {presetList && presetList.length === 0 && (
        <div
          className="mask"
          style={{
            zIndex: 1,
            textAlign: "center",
            backgroundColor: "white",
          }}
        >
          <div>
            <div
              style={{
                color: "black",
                fontWeight: "600",
                marginBottom: "16px",
              }}
            >
              No presets available
            </div>
            <div style={{ color: "black", marginBottom: "16px" }}>
              Add a preset to set regions and detection algorithms.
            </div>
            <Button className="primaryButton" onClick={onAddPreset}>
              + Preset
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
